export default {
  hitos: {
    // Grupos del catálogo (§89). El nombre canónico viene de la API (grupo_nombre);
    // estas etiquetas son las cortas para chips y filtros.
    group1: "Aprobación",
    group2: "Financiación",
    group3: "Comercialización",
    group4: "Agrupaciones homogéneas y precios de referencia",
    group5: "Condiciones de financiación y dispensación",
    group6: "Precios",
    group7: "Seguridad",
    group8: "Registro y datos técnicos",
    group9: "Protección y exclusividad",
    group10: "Acceso hospitalario",
    group11: "Normativo transversal",
    // Filtros y columnas
    // Etiquetas CORTAS para chips de tabla (el nombre completo estrechaba la columna Producto)
    groupShort1: "Aprobación",
    groupShort2: "Financiación",
    groupShort3: "Comercialización",
    groupShort4: "Agrup. homogéneas / PR",
    groupShort5: "Cond. financiación",
    groupShort6: "Precios",
    groupShort7: "Seguridad",
    groupShort8: "Registro",
    groupShort9: "Protección",
    groupShort10: "Acceso hospitalario",
    groupShort11: "Normativo",
    group: "Grupo de hitos",
    hito: "Hito",
    severity: "Severidad",
    allGroups: "Todos los grupos",
    allHitos: "Todos los hitos",
    allSeverities: "Toda severidad",
    colGroup: "Grupo",
    colHito: "Hito",
    colSeverity: "Severidad",
    // Severidad = urgencia de acción, no signo de la noticia
    sevA: "A · acción con plazo",
    sevD: "D · requiere decisión",
    sevI: "I · informativo",
    sevAShort: "Acción",
    sevDShort: "Decisión",
    sevIShort: "Info",
    // Sentido (R-19): favorable / adverso para quien mira, por hito × titularidad
    sentido_favorable: "Sentido: favorable para ti",
    sentido_adverso: "Sentido: adverso para ti",
    sentido_neutro: "Sentido: neutro",
    noHito: "Sin clasificar",
    // Catálogo 3.9 (28 sep 2026)
    structurePdf: "Estructura de hitos (PDF)",
    structurePdfFull: "Ver la estructura completa de hitos (PDF)",
    sheetTitle: "Ficha del hito",
    sheetClose: "Cerrar",
    sheetDescription: "Qué es",
    sheetCatalogSources: "Fuentes del catálogo",
    sheetMonitoredSince: "Vigilado desde",
    sheetHelixSources: "Fuentes de HelixScan",
    sheetSince: "desde el {date}",
    critOn: "Alerta crítica",
    critOff: "No es crítica",
    critAria: "Alerta crítica: {hito}",
    critDefaultOn: "De fábrica: crítica",
    critDefaultOff: "De fábrica: no crítica",
    sheetCritical: "Alerta crítica de fábrica",
    sheetCriticalOwn: "tu producto: {v}",
    sheetCriticalComp: "competencia: {v}",
    yes: "sí",
    no: "no",
    sheetFrequency: "Frecuencia",
    sheetWindow: "Ventana",
    sheetHistoryNote: "Lo publicado antes de que HelixScan vigilara la fuente no genera eventos ni avisos: es historia y está en la ficha de cada producto.",
    sheetOpen: "Ver la ficha del hito",
    monitoringSince: "HelixScan monitoriza eventos desde el {date}, la fecha de sus primeras fuentes; cada fuente tiene la suya (en la ficha de cada hito y en Fuentes). Lo anterior es historia: está en la ficha de cada producto.",
    firstCompetitor: "Primer competidor",
    firstCompetitorHint: "Es el primer competidor que entra en una agrupación homogénea donde solo estaba tu cartera",
    abovePM: "Por encima del precio menor",
    abovePMHint: "El PVP de este CN queda por encima del nuevo precio menor de su agrupación: pierde la sustitución",
    historico: "Anterior a la vigilancia",
    historicoHint: "Hecho anterior a la fecha en que HelixScan empezó a vigilar la fuente: se guarda como historia, no como evento",
    inactivo: "inactivo en esta edición",
    sinCobertura: "sin cobertura todavía",
    // Severidad por organización
    tabSeverity: "Severidad",
    tabTexts: "Textos de los avisos",
    txtIntro: "Es el «Por qué importa» que acompaña a cada aviso por correo, según el producto sea tuyo o de la competencia. Vienen los textos del catálogo de hitos; lo que cambies aquí vale para toda tu organización. Déjalo vacío para volver al texto de fábrica.",
    txtLanguage: "Idioma del texto:",
    txtColPropio: "Si es tu producto",
    txtColCompetencia: "Si es de la competencia o de una agrupación vigilada",
    txtSave: "Guardar",
    txtCancel: "Cancelar",
    txtCustom: "Texto de tu organización",
    txtRestore: "Volver al texto de fábrica",
    sevPageTitle: "Severidad por hito",
    sevPageIntro: "La severidad es la urgencia de actuar, según el hito y la relación del producto con tu cartera. Los valores por defecto son los del catálogo de hitos; lo que cambies aquí vale para toda tu organización y prevalece. La marca «Alerta crítica» es aparte del nivel: esos eventos llegan por correo destacados («[CRÍTICO]» en el asunto) y en cuanto se detectan a quien tenga activadas las alertas críticas.",
    sevColPropio: "Si es propio",
    sevColCompetencia: "Si es de la competencia o de una agrupación sin producto propio",
    sevDefault: "Por defecto: {sev}",
    sevRestoreAll: "Restaurar todo ({n} cambios)",
    sevRestoreAllTitle: "¿Volver a la severidad y las alertas críticas de fábrica?",
    sevRestoreAllMsg: "Se deshacen los {n} cambios de tu organización y vuelven los valores del catálogo de hitos.",
    txtRestoreAll: "Restaurar todo ({n} textos)",
    txtRestoreAllTitle: "¿Volver a los textos de fábrica?",
    txtRestoreAllMsg: "Se borran los {n} textos propios de tu organización (en español y en inglés) y vuelven los del catálogo.",
    restoreConfirm: "Restaurar",
    sevRestore: "Volver al valor por defecto",
    sevDesenlaces: "Según el desenlace o la sección",
    sevNa: "No se dispara",
    sevReadOnly: "Solo el administrador de tu organización puede cambiarla.",
    sevSaved: "Guardado",
    sevSearch: "Buscar hito…",
    sevOnlyCovered: "Solo hitos que HelixScan detecta hoy",
  },
};
